import { AppDialog } from "../../../../common/components/AppDialog/AppDialog";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { ReviewForm } from "../../../reviews/components/ReviewForm/ReviewForm";
import { IReviewFormModel } from "../../../reviews/models/reviewFormModel";
import { IStudioReviewModel } from "../../../reviews/models/reviewModels";
import styles from "./LeaveReviewDialog.module.scss";

interface ILeaveReviewDialogProps {
  visible: boolean;
  studioName?: string;
  review: IStudioReviewModel | null;
  initialValues?: IReviewFormModel;
  isSaving: boolean;
  onSave: (values: IReviewFormModel) => void;
  onHide: () => void;
}

export const LeaveReviewDialog = ({
  visible,
  studioName,
  review,
  initialValues,
  isSaving,
  onSave,
  onHide,
}: ILeaveReviewDialogProps) => (
  <AppDialog
    header={review ? "Вашето ревю" : "Остави ревю"}
    visible={visible}
    onHide={onHide}
    className={styles.dialog}
    // The comment is typed work; a stray click on the backdrop should not lose it.
    dismissableMask={false}
  >
    <div className={styles.root}>
      <p className={styles.root_question}>
        {studioName ? `Как беше в ${studioName}?` : "Как беше?"}
      </p>

      <ReviewForm
        initialValues={initialValues}
        isEdit={!!review}
        isSaving={isSaving}
        onSubmit={onSave}
      />

      <RenderWhen condition={!!review?.ownerReply}>
        <div className={styles.root_reply}>
          <span className={styles.root_reply_label}>Отговор от студиото:</span>
          <p className={styles.root_reply_text}>{review?.ownerReply}</p>
        </div>
      </RenderWhen>
    </div>
  </AppDialog>
);
